<script setup>
  import { computed, onMounted, onUpdated, ref } from "vue";

  import {
    formatTwoDigits,
    getLabelByValue,
    handleMonitoringStatusChipOption,
  } from "@/utils";
  import { GENDER_OPTIONS } from "@/utils/constant";
  import ExtendExamTimeModal from "./ExtendExamTimeModal.vue";
  import ReApplyModal from "./ReApplyModal.vue";

  const props = defineProps({
    show: {
      type: Boolean,
      required: true,
    },
    examStatus: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    nextTour: { type: Function, required: true },
  });

  const emits = defineEmits(["update:show"]);

  const localShow = computed({
    get: () => props.show,
    set: (val) => emits("update:show", val),
  });

  const closeModal = () => {
    props.nextTour();
    emits("update:show", false);
  };

  // 상태
  const chipOption = computed(() => {
    return handleMonitoringStatusChipOption(props.item.status);
  });

  // 상세정보
  const detailData = ref({
    questions: []
  });
  const groupedQuestions = ref([]);
  const fetchDetailData = () => {
    const tempRes = {
      school: "웨일초등학교",
      studentName: props.item.name,
      gradeClass: "4-1",
      number: props.item.number,
      gender: "F",
      userId: "test" + props.item.number + "@senedu.kr",
      examTime: "2025.10.29 09:35~10:25 (+10분 추가)",
      questions: [
        { number: 1, answer: null, type: "select", status: "unsolved" },
        { number: 2, answer: null, type: "select", status: "unsolved" },
        { number: 3, answer: null, type: "select", status: "unsolved" },
        { number: 4, answer: null, type: "select", status: "unsolved" },
        { number: 5, answer: null, type: "select", status: "unsolved" },
        { number: 6, answer: null, type: "select", status: "unsolved" },
        { number: 7, answer: null, type: "select", status: "unsolved" },
        { number: 8, answer: null, type: "select", status: "unsolved" },
        { number: 9, answer: null, type: "select", status: "unsolved" },
        { number: 10, answer: null, type: "select", status: "unsolved" },
        { number: 11, answer: null, type: "select", status: "unsolved" },
        { number: 12, answer: null, type: "select", status: "unsolved" },
        { number: 13, answer: null, type: "select", status: "unsolved" },
        { number: 14, answer: null, type: "select", status: "unsolved" },
        { number: 15, answer: null, type: "select", status: "unsolved" },
        { number: 16, answer: null, type: "select", status: "unsolved" },
        { number: 17, answer: null, type: "select", status: "unsolved" },
        { number: 18, answer: null, type: "select", status: "unsolved" },
        { number: 19, answer: null, type: "select", status: "unsolved" },
        { number: 20, answer: null, type: "select", status: "unsolved" },
      ],
    };

    detailData.value = tempRes;

    if (props.examStatus === "running"
      || props.examStatus === "end") {

      let questions = [];
      if (props.examStatus === "running") {
        questions = [
          { number: 1, answer: null, type: "select", status: "unsolved" },
          { number: 2, answer: "①", type: "select", status: "solved" },
          { number: 3, answer: "①,②", type: "select", status: "solved" },
          { number: 4, answer: null, type: "write", status: "unsolved" },
          { number: 5, answer: "주관식", type: "write", status: "solved" },
          { number: 6, answer: null, type: "select", status: "unsolved" },
          { number: 7, answer: null, type: "select", status: "unsolved" },
          { number: 8, answer: null, type: "select", status: "unsolved" },
          { number: 9, answer: null, type: "select", status: "unsolved" },
          { number: 10, answer: null, type: "select", status: "unsolved" },
          { number: 11, answer: null, type: "select", status: "unsolved" },
          { number: 12, answer: null, type: "select", status: "unsolved" },
          { number: 13, answer: null, type: "select", status: "unsolved" },
          { number: 14, answer: null, type: "select", status: "unsolved" },
          { number: 15, answer: null, type: "select", status: "unsolved" },
          { number: 16, answer: null, type: "select", status: "unsolved" },
          { number: 17, answer: null, type: "select", status: "unsolved" },
          { number: 18, answer: null, type: "select", status: "unsolved" },
          { number: 19, answer: null, type: "select", status: "unsolved" },
          { number: 20, answer: null, type: "select", status: "unsolved" },
        ];
      }
      else if (props.examStatus === "end") {
        questions = [
          { number: 1, answer: "③", type: "select", status: "solved" },
          { number: 2, answer: "①", type: "select", status: "solved" },
          { number: 3, answer: "①,②", type: "select", status: "solved" },
          { number: 4, answer: "주관식", type: "write", status: "solved" },
          { number: 5, answer: "주관식", type: "write", status: "solved" },
          { number: 6, answer: "③", type: "select", status: "solved" },
          { number: 7, answer: "④", type: "select", status: "solved" },
          { number: 8, answer: "⑤", type: "select", status: "solved" },
          { number: 9, answer: "④", type: "select", status: "solved" },
          { number: 10, answer: "⑤", type: "select", status: "solved" },
          { number: 11, answer: "주관식", type: "write", status: "solved" },
          { number: 12, answer: "①,②", type: "select", status: "solved" },
          { number: 13, answer: "①", type: "select", status: "solved" },
          { number: 14, answer: "①", type: "select", status: "solved" },
          { number: 15, answer: "①", type: "select", status: "solved" },
          { number: 16, answer: "③", type: "select", status: "solved" },
          { number: 17, answer: "④", type: "select", status: "solved" },
          { number: 18, answer: "⑤", type: "select", status: "solved" },
          { number: 19, answer: "⑤", type: "select", status: "solved" },
          { number: 20, answer: "⑤", type: "select", status: "solved" },
        ];
      }

      detailData.value.questions = questions;

      for (let i = 0; i < questions.length; i += 10) {
        groupedQuestions.value.push(questions.slice(i, i + 10));
      }
    }
  };

  const handleAnswerText = (item) => {
    if (item.status === "unsolved") {
      return "미입력";
    }
    if (item.type === "write") {
      return "입력";
    }
    return item.answer;
  };

  // 시험 시간 추가
  const isOpenExtendTimeModal = ref(false);
  1;
  const openExtendTimeModal = () => {
    isOpenExtendTimeModal.value = true;
  };

  // 재응시
  const isOpenReApplyModal = ref(false);
  1;
  const openReApplyModal = () => {
    isOpenReApplyModal.value = true;
  };

  const solvedCount = computed(
    () =>
      detailData.value.questions.filter((item) => item.status === "solved")
        .length,
  );

  const unSolvedCount = computed(
    () =>
      detailData.value.questions.filter((item) => item.status === "unsolved")
        .length,
  );

  // Tour 처리
  const afterEnter = () => {
    fetchDetailData();
    props.nextTour();
  };

  const endTourSttus = ref("1");
  const stopTourExam = () => {
    endTourSttus.value = "2";
    props.nextTour();
  };


</script>

<template>
  <ui-modal
    v-model:show="localShow"
    :title="false"
    :maskClosable="true"
    size="lg"
    @after-enter="afterEnter"
  >
    <template #header>
      <n-flex align="center">
        <ui-chip
          :color="chipOption.color"
          :variant="chipOption.variant"
          size="sm"
          >{{ item.status }}</ui-chip
        >
        <span>
          {{ formatTwoDigits(item.number) }}
          {{ item.name }}
        </span>

        <ui-button
          id="tour-exmne-modal-chnpw"
          v-if="examStatus === 'unable'"
          variant="outlined"
          size="tiny"
          class="justify-start font-normal"
        >비밀번호 초기화</ui-button
        >
      </n-flex>
    </template>
    <template #body>
      <ui-table variant="bordered" id="tour-exmne-modal-info">
        <colgroup>
          <col style="width: 100px" />
          <col style="width: auto" />
          <col style="width: 100px" />
          <col style="width: auto" />
          <col style="width: 100px" />
          <col style="width: auto" />
        </colgroup>
        <tbody>
          <tr>
            <th class="text-center">학교</th>
            <td>{{ detailData.school }}</td>
            <th class="text-center">이름</th>
            <td>{{ detailData.studentName }}</td>
            <th class="text-center">학년-반</th>
            <td>{{ detailData.gradeClass }}</td>
          </tr>
          <tr>
            <th class="text-center">번호</th>
            <td>{{ detailData.number }}</td>
            <th class="text-center">성별</th>
            <td>{{ getLabelByValue(detailData.gender, GENDER_OPTIONS) }}</td>
            <th class="text-center">아이디</th>
            <td>{{ detailData.userId }}</td>
          </tr>
          <tr>
            <th class="text-center">시험 시간</th>
            <td colspan="5">
              <div class="relative">
                <template v-if="examStatus === 'unable'">
                  <span> - </span>
                </template>
                <template v-else-if="examStatus === 'waiting'">
                  <span>2025.10.29 09:35~10:25</span>
                  <ui-button
                    size="tiny"
                    variant="outlined"
                    class="absolute -top-2.5 right-0"
                    @click="openExtendTimeModal"
                  >추가</ui-button
                  >
                </template>
                <template v-else-if="examStatus === 'running'">
                  <template v-if="item.number === 21">
                    <span>2025.10.29 09:35~10:25 (+5분 연장)</span>
                    <ui-button
                      id="tour-detail-modal-re"
                      size="tiny"
                      variant="outlined"
                      class="absolute -top-2.5 right-0"
                    >재응시 설정</ui-button
                    >
                  </template>
                  <template v-if="item.number === 16">
                    <span>2025.10.29 09:35~10:25 (+10분 연장)</span>
                    <ui-button
                      id="tour-exmne-16-detail-modal"
                      size="tiny"
                      variant="outlined"
                      class="absolute -top-2.5 right-0"
                    >추가</ui-button
                    >
                  </template>
                </template>
                <template v-else-if="examStatus === 'end'">
                  <span>2025.10.29 09:35~10:25 (+10분 연장)</span>
                </template>
              </div>
            </td>
          </tr>
          <template v-if="examStatus === 'waiting'">
            <tr>
              <th class="text-center">시험 중단 ③</th>
              <td colspan="5">
                <ui-button
                  id="tour-detail-modal-stop"
                  size="tiny"
                  variant="outlined"
                  @click="openReApplyModal"
                >[시험 중단] 교사 확인 – 재응시 처리
                </ui-button>
              </td>
            </tr>
          </template>
          <template v-else-if="examStatus === 'running'">
            <template v-if="item.number === 21">
              <tr>
                <th class="text-center">연장 이력 ③</th>
                <td colspan="5">
                  [이바른] 2025.10.29 09:36 (+5분 추가) 교사 확인 추가
                </td>
              </tr>
            </template>
            <template v-if="item.number === 16">
              <tr>
                <th class="text-center">연장 이력 ③</th>
                <td colspan="5">
                  [이바른] 2025.10.29 09:36 (+5분 추가) 교사 확인 추가
                </td>
              </tr>
              <tr id="tour-exmne-16-detail-modal-history">
                <th class="text-center">연장 이력 ②</th>
                <td colspan="5">
                  [이바른] 2025.10.29 10:05 (+5분 추가) 교사 확인 추가
                </td>
              </tr>
            </template>
          </template>
          <template v-else-if="examStatus === 'end'">
            <tr>
              <th class="text-center">연장 이력 ③</th>
              <td colspan="5">
                [이바른] 2025.10.29 09:36 (+5분 추가) 교사 확인 추가
              </td>
            </tr>
            <tr id="tour-exmne-16-detail-modal-history">
              <th class="text-center">연장 이력 ②</th>
              <td colspan="5">
                [이바른] 2025.10.29 10:05 (+5분 추가) 교사 확인 추가
              </td>
            </tr>
            <tr>
              <th class="text-center">시험 중단 ③</th>
              <td colspan="5">
                <template v-if="endTourSttus === '1'">
                  <ui-button
                    id="tour-16-detail-modal-stop"
                    size="tiny"
                    variant="outlined"
                    @click="stopTourExam"
                  >[시험 중단] 교사 확인 – 시험 종료 제출 처리
                  </ui-button>
                </template>
                <template v-if="endTourSttus === '2'">
                  [이바른] 2025.10.29 10:05 (+5분 추가) 교사 확인 추가
                </template>
              </td>
            </tr>
          </template>
        </tbody>
      </ui-table>

      <div id="tour-exmne-modal-queslist">
        <n-flex align="center" class="mt-4">
          <p>
            푼 문제 수:
            <strong class="text-gray-800">{{ solvedCount }}</strong>
          </p>
          <n-divider vertical class="h-3" />
          <p>
            안 푼 문제 수:
            <strong class="text-red-500">{{ unSolvedCount }}</strong>
          </p>
        </n-flex>
        <ui-table variant="answer" container-class="mt-2">
        <tbody>
          <template v-if="groupedQuestions.length > 0">
            <tr
              v-for="(groupItem, groupIndex) in groupedQuestions"
              :key="`group-${groupIndex}`"
            >
              <td
                v-for="(item, index) in groupItem"
                :key="`group-${groupIndex}-${index}`"
              >
                <div
                  class="answer-cell"
                  :class="[
                    {
                      unsolved: item.status === 'unsolved',
                    },
                  ]"
                >
                  <div class="answer-th">{{ item.number }}</div>
                  <div class="answer-td">{{ handleAnswerText(item) }}</div>
                </div>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="9">
              <ui-empty>
                <template #text
                >미응시 학생입니다.</template
                >
<!--                <template #extra
                >미응시 학생입니다.</template
                >-->
              </ui-empty>
            </td>
          </tr>
        </tbody>
      </ui-table>
      </div>
    </template>
    <template #footer>
      <div class="btn-area justify-end">
        <ui-button
          id="tour-detail-modal-confirm"
          @click="closeModal">확인 </ui-button>
      </div>
    </template>
  </ui-modal>

  <!-- 시험 시간 추가 -->
  <ExtendExamTimeModal v-model:show="isOpenExtendTimeModal" />

  <!-- 재응시 설정 -->
  <ReApplyModal
    v-model:show="isOpenReApplyModal"
    :next-tour="nextTour"
  />
</template>
